<template>
    <div class="page">
        <v-header :selectedItemVal="3" style="background:white"></v-header>
		
        <div class="main">
            <div class="page_tag">
                    首页 &nbsp;> &nbsp; 直播
            </div>
            <div class="liveVideo_big" :style="{height:pageHeight}">
                <div class="liveVideo_big_left">
                    <div class="lv_video_desc">
						<div class="lv_user_div">
						    <div class="lv_user_div_avatar">
						        <img :src="liveDetail.udPhotoFileid" class="lv_user_div_avatar_img" v-if="liveDetail.udPhotoFileid" alt="">
								<img src="../../assets/img/logo.png" class="lv_user_div_avatar_img" v-else alt="">
						    </div>
						    <div class="lv_user_div_uInfo">
						        <div class="lv_user_div_uInfo_title">{{ liveDetail.lvrName }}</div>
						        <div class="lv_user_div_uInfo_name">{{ liveDetail.udNickname }}</div>
						    </div>
						</div>
						<div class="lv_room_info">
						        <div class="lv_room_info_bg lv_room_info_left">热度：{{ liveDetail.hotNum }}</div>
						        <div class="lv_room_info_bg lv_room_info_right">房间号：{{ liveDetail.lvrRoomId }}</div>
						</div>
					</div>
                    <div class="lv_video_info">
						<v-livePlay ref="livePlay" @liveDetailChange="liveDetailChange($event)"></v-livePlay>
                    </div>
                </div>
				
                <div class="liveVideo_big_right">
                    <div class="k_right_comment_top">
					    <img src="../../assets/img/live/讨论区.png" alt="">
				    </div>
                    <div class="lv_right_discuss">
                        <div class="discuss_list">
                            <div class="discuss_list_item"  v-for="(item,index) in liveComments" :key="index">
                                <div class="discuss_list_item_userInfo" v-if="item.commentType != 3">
                                    <div class="discuss_list_item_uInfo_avatar">
                                        <img :src="item.user.avatar" v-if="item.user.avatar" alt="">
										<img src="../../assets/img/logo.png" v-else alt="">
                                    </div>
                                    <div class="discuss_list_item_uInfo_name" :style="{color:item.user.name.color}">
                                        {{item.user.name.text}}
                                    </div>
                                    <div v-if="item.user.tag" class="discuss_list_item_tag" :style="{background:item.user.tag.bgColor}">
                                        {{item.user.tag.text}}
                                    </div>
                                    <div v-if="item.time"  class="discuss_list_item_time">{{item.time}}</div>
                                </div>
                                <div class="discuss_list_item_comment">{{item.comment}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="lv_right_send">
                        <input type="text" placeholder="说点什么吧" class="lv_right_input" v-model="bulletChatText" @keyup.enter="sendBulletChat()">
                        <input type="button" class="lv_right_btn" value="发送" @click="sendBulletChat()">
                    </div>
                </div>
            </div>
            <div v-if="liveEnclosure.length" class="enclosure">
                <div>附件:</div>
				<div>
					<span v-for="(item,index) in liveEnclosure" @click="downloadEnclosure(item)">{{item.imgeName}}</span>
				</div>
            </div>
            <div class="play_back">
                <div class="title">
                    <h2>直播回放</h2>
                </div>
                <div class="content">
                    <v-playback :playbackData="playbackList" ref="livePlayback" @getLiveDetail="getLiveDetail($event)"></v-playback>
                </div>
				<div class="paginate">
					<el-pagination
						background
						:layout="paginate.layout"
						:page-count="paginate.pageCount"
						:hide-on-single-page="paginate.singleHidePage"
						@current-change="currentChange">
					</el-pagination>
				</div>
			</div>
        </div>
		<v-footer></v-footer>
    </div>
</template>
<script>
	import vHeader from '../common/header'
	import vFooter from '../common/footer'
	import vPlayback from '../common/playback'
	import vBuyCard from '../common/buy_card'
	import vLivePlay from '../common/livePlay'
	import commonJs from '../../../static/js/common.js'
	export default {
		name:"liveDetail",
		data(){
		     return {
				nowRoomId:0,
				liveDetail:{},
				bulletChatText:'',
				client:{},
				aliPlayer:{},
				commentNum:0,
				playbackList:[],
				liveComments:[],
				liveEnclosure:[],
				paginate:{
					// "total":12,
					"pageCount":0,
					"layout":"prev, pager, next",
					"currentPage":1,
					"singleHidePage":true,
				},
		     }
		 },
		components:{
			'v-header':vHeader,
			'v-footer':vFooter,
			'v-playback':vPlayback,
			'v-buyCard':vBuyCard,
			'v-livePlay':vLivePlay,
		},
        computed:{
            pageWidth:function(){
                // return document.body.clientWidth - (359 * 2) + 'px'
                return "1203px";
            },
            pageHeight:function(){
                var pageWidth = document.body.clientWidth - (359 * 2)
                //原本的宽高比 1203 | 605
                //根据新的宽 计算出新的高
                var r = 1203 / 605
                var pageHeight = pageWidth / r
                // return pageHeight + 'px'
                return "650px";
            },
			
        },
		watch: {
			liveComments:'commentScrollToBottom',
			bulletChatText:'checkDanmuText',
		},
		mounted(){
			//+-----------更新当前直播间id-------------
			this.nowRoomId = this.$route.query.room_id;
			//+-----------获取直播详情数据-------------
			this.getLiveDetail();
			
			//+------------获取弹幕评论数据-----------
			this.liveComments = this.$refs.livePlay.liveComments;
			this.commentNum = this.$refs.commentNum;
			
			//+-----------获取直播对应相关回放数据-----
			this.getPlaybackList();
		},
        methods: {
			//获取直播详情 【childItem，点击录播】
			getLiveDetail(childItem){
				//+--------------------录播传递数据存在---------------------------
				if(childItem){
					//更新房间id
					this.nowRoomId = childItem.fkLvrId;
					//更新附件信息
					this.liveEnclosure = childItem.imageList;
				}
				
				//校验当前直播id
				if(!this.nowRoomId){
					this.$message.error('参数异常或直播间不存在');
					return false;
				}
				//更新直播
				this.$refs.livePlay.nowRoomId = this.nowRoomId;
			},
			//获取相关直播回放列表
			getPlaybackList(){
				//+-------------------------构建请求参数-------------------
				let data = {
					lvrId:this.nowRoomId,	//房间id
					page:this.paginate.currentPage,
					lvrrType:2,	//用户查看已发布的列表不传 ，其余情况传2
					lvrrId:0,	//当前播放的录播id
				};
				//+-------------------------请求回放列表数据--------------
				this.apiServer.live.getPlaybackList(this.qs.stringify(data))
				.then(res => {
					if(res.data.code == 200){
						if(res.data.data.businessCode != 10){
							this.$message.error(res.data.data.businessMessage);
							return false;
						}
						//更新该直播间相关录播列表数据
						this.playbackList = res.data.data.info;
						
						//更新列表总页数
						this.paginate.pageCount = res.data.data.pageTotal;
					}
				})
				.catch(error => {
					this.$message.error('获取相关直播回放异常');
				});
			},
			//下载附件
            downloadEnclosure(item){
                //+--------------------访问附件地址----------------------------
				window.location.href = item.imgeUrl;
            },
			//发送弹幕
			sendBulletChat(){
				if(!this.store.state.user){
					this.$router.push({path:'/'});
				}
				//+--------------------构建请求参数----------------------------
				var sendText = commonJs.stringTrim(this.bulletChatText);
				let data = {
					lvrId:this.nowRoomId,
					info:sendText,
				};
				//+--------------------发送弹幕-------------------------------
				this.apiServer.live.sendBulletChat(this.qs.stringify(data))
				.then(res => {
					if(res.data.code == 200){
						if(res.data.data.businessCode != 10){
							this.$message(res.data.data.businessMessage);
							return false;
						}
						
						let userInfo = JSON.parse(this.store.state.user);
						//实时追加评论到列表
						let commentItem = {
							// id:json.data.ub_id,
							comment:sendText,
							// commentType:json.data.info_type,
							time:'刚刚',
							user:{
								name:{
									text:userInfo.udNickname,
									color:'#C60B09',
								},
								tag : {
								    bgColor:"#C60B09",
								    text :'用户'
								},
								avatar:userInfo.udPhotoFileid,
							},
						}
						
						this.liveComments.push(commentItem);
						//发送成功，清空输入框
						this.bulletChatText = '';
					}
				})
				.catch(error => {
					this.$message.error('弹幕发送异常');
				});
			},
			//接收直播详情数据
			liveDetailChange(liveDetail){
				this.liveDetail = liveDetail;
			},
			//弹幕评论滚动到最新
			commentScrollToBottom(){
				var commentBox = document.querySelector('.discuss_list');
				commentBox.scrollTop = commentBox.scrollHeight;
			},
			//列表页码改变事件
			currentChange:function(currentPage){
				this.paginate.currentPage = currentPage;
				
				//+------------请求新页码直播回放数据----------------
				this.getPlaybackList();
			},
			//检测并清除弹幕特殊符号
			checkDanmuText(){
				this.bulletChatText = commonJs.stringTrim(this.bulletChatText);
			}
        }
    }
</script>
<style scoped>
    .page{
        background-color:#F2F2F2;
        height:100%;
        width:100%;
    }
    .page_tag{
        margin-top:15px;
        height: 30px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: #222222;
        line-height: 30px;
        margin-bottom: 15px;
    }
    .main{
		width: 1250px;
        border-radius:12px;
        margin: 0 auto;
    }
    .liveVideo_big{
        background:#222222;
        border-radius: 12px;
        margin-bottom: 32px;
    }
    .lv_user_div_avatar_img{
        width:48px;
        height:48px;
        border-radius: 48px;
    }
    .liveVideo_big_left{
      width: 1000px;
      margin-left: 21px;
      float:left;
    }
	
	.lv_video_desc{
		height: 70px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
	
    .lv_user_div{
        margin-left: 6px;
        margin-bottom: 16px;
        margin-top: 22px;
    }
    .lv_user_div_avatar{
        float: left;
    }
    .lv_user_div_uInfo{
        float: left;
        margin-left: 16px;
    }
    .lv_user_div_uInfo_title{
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 25px;
    }
    .lv_user_div_uInfo_name{
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
    }
    .lv_room_info{
        width:280px;
        height:40px;
        margin-top: 22px;
    }
    .lv_room_info_bg{
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 40px;
        width: 140px;
        float: left;
        text-align: center;
    }
    .lv_room_info_left{
        background:red;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }
    .lv_room_info_right{
        background:#666666;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
    .lv_video_info{
        height:565px;
        display: flex;
        margin-bottom: 16px;
        flex-direction:column;
		background: url(../../assets/img/live/no_play.png) no-repeat;
		background-size: cover;
    }
    .lv_video_info video {
		width:882px;
        height:499px;
        margin-bottom: 16px;
        border-radius: 6px;
    }
    .liveVideo_big_right{
        width: 273px;
        height: 615px;
        background: #666666;
        border-radius: 2px;
        float:left;
        margin-top: 17px;
        margin-left: 13px;
    }
    .k_right_comment_top{
        top: -17px;
        left: 64px;
        position: relative;
    }
    .discuss_list{
        height:516px;
        overflow-y:scroll;
    }
    ::-webkit-scrollbar {
		/*隐藏滚轮*/
		display: none;
	}
    .discuss_list_item{
        margin-left: 23px;
        margin-right: 23px;
        margin-bottom: 18px;
    }
    .discuss_list_item_uInfo_avatar img{
        width: 32px;
        height: 32px;
        border-radius: 32px;
        float: left;
        margin-right: 6px;
    }
    .discuss_list_item_uInfo_name{
        float: left;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 22px;
    }
    .discuss_list_item_tag{
        width: 32px;
        height: 20px;
        display: inline-block;
        margin-left: 2px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
        text-align: center;
    }
    .discuss_list_item_comment{
        margin-top: 11px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
        margin-left: 39px;
		word-break: break-all;
    }
    .discuss_list_item_time{
        margin-left: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        float: left;
        display: contents;
    }
    .lv_right_send .lv_right_input{
        width: 170px;
        height: 30px;
        background: #222222;
        border-radius: 8px;
        margin-left: 23px;
        color: #FFFFFF;
        padding-left:10px;
        padding-right: 10px;
    }
    .lv_right_send .lv_right_btn{
        width: 48px;
        height: 32px;
        background: #C60B09;
        border-radius: 8px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 32px;
        text-align: center;
        border-top-style: none;
        border-right-style: none;
        border-bottom-style: none;
        border-left-style: none;
    }
    input, button, select, textarea {
        outline: none;
        -webkit-appearance: none;
        border-radius: 0;
    }
    input{  
        background:none;  
        outline:none;  
        border:none;
    }
    .enclosure{
        height: 42px;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        display: inline-flex;
        line-height: 42px;
        margin-bottom: 21px;
    }
    .enclosure span{
        color:red;
		cursor: pointer;
    }
	
	.paginate{
		text-align: center;
	}
	
	.not_freeLiving{
		position: relative;
	}
	.freeLiveDesc{
		position: absolute;
		color: #FFFFFF;
		top: 158px;
		left: 294px;
	}
	
	.not_payLiving{
		position: relative;
	}
	.payLiveDesc{
		position: absolute;
		color: #FFFFFF;
		top: 158px;
		text-align: center;
	}
	
	.not_living-title{
		width: 240px;
		height: 42px;
		font-size: 30px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		line-height: 42px;
		margin-top: 80px;
		margin-left: 321px;
		margin-bottom: 21px;
	}
	.not_living-desc{
		width: 315px;
		height: 29px;
		font-size: 21px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 29px;
		margin-left: 294px;
		margin-bottom: 32px;
	}
	.not_living-pay{
		width: 253px;
		height: 60px;
		background: linear-gradient(102deg, #FCE482 0%, #F7C54B 100%);
		border-radius: 4px;
		margin-left: 315px;
		margin-bottom: 157px;
		font-size: 30px;
		color: #000000;
		cursor: pointer;
		line-height: 60px;
	}
</style>




// WEBPACK FOOTER //
// src/components/live/liveDetail.vue